import { render, staticRenderFns } from "./specialreportList.vue?vue&type=template&id=2050704c&scoped=true&"
import script from "./specialreportList.vue?vue&type=script&lang=js&"
export * from "./specialreportList.vue?vue&type=script&lang=js&"
import style0 from "./specialreportList.vue?vue&type=style&index=0&id=2050704c&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2050704c",
  null
  
)

export default component.exports